module.exports = __webpack_public_path__ + "img/ic_organizer.7427a53e.svg";